export var CLDynamicLinkBehaviour;
(function (CLDynamicLinkBehaviour) {
    CLDynamicLinkBehaviour[CLDynamicLinkBehaviour["browser"] = 1] = "browser";
    CLDynamicLinkBehaviour[CLDynamicLinkBehaviour["app"] = 2] = "app";
})(CLDynamicLinkBehaviour || (CLDynamicLinkBehaviour = {}));
//# sourceMappingURL=definitions.js.map